// 주민등록번호 / 외국인등록번호 유효성 검증 함수
export function validateKoreanID(id: string): {
  valid: boolean;
  reason?: string;
  type?: string;
  birthDate?: string;
} {
  // 1. 기본 포맷 확인
  const reg = /^(\d{6})[-]?(\d{7})$/;
  if (!reg.test(id)) return { valid: false, reason: '형식이 올바르지 않습니다.' };

  const digits = id.replace('-', '').split('').map(Number);
  const birth = id.substring(0, 6);
  const type = digits[6]; // 성별/세기/외국인 구분

  // 2. 생년월일 검증
  const yearPrefix = (type <= 2 || (type >= 5 && type <= 6)) ? 1900 :
                     (type <= 4 || (type >= 7 && type <= 8)) ? 2000 : 1800;
  const year = yearPrefix + Number(birth.substring(0, 2));
  const month = Number(birth.substring(2, 4));
  const day = Number(birth.substring(4, 6));

  const birthDate = new Date(year, month - 1, day);
  if (
    birthDate.getFullYear() !== year ||
    birthDate.getMonth() + 1 !== month ||
    birthDate.getDate() !== day
  ) {
    return { valid: false, reason: '유효하지 않은 생년월일입니다.' };
  }

  // 3. 가중치 계산 (체크디지트)
  const multipliers = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
  const sum = digits.slice(0, 12).reduce((acc, d, i) => acc + d * multipliers[i], 0);
  let check = (11 - (sum % 11)) % 10;

  // 외국인등록번호는 마지막 자리 +2 처리 후 10으로 나눈 나머지를 비교
  if (type >= 5 && type <= 8) {
    check = (check + 2) % 10;
  }

  const isValid = check === digits[12];
  if (!isValid) return { valid: false, reason: '체크디지트 불일치 (잘못된 주민번호)' };

  return {
    valid: true,
    type: (type >= 5 && type <= 8) ? '외국인' : '내국인',
    birthDate: `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
  };
}
